import settings from 'ribbon/settings';

import { defineWidget, hookMethod } from '@merkur/core';
import { componentPlugin, createViewFactory } from '@merkur/plugin-component';
import { ERROR_EVENTS, errorPlugin } from '@merkur/plugin-error';
import { eventEmitterPlugin } from '@merkur/plugin-event-emitter';
import { httpClientPlugin } from '@merkur/plugin-http-client';

import errorHandler from './lib/errorHandler';
import { enableDebug } from './lib/Log';
import SuggestApi from './lib/SuggestApi';
import { View } from './view/View';
import { name, version } from '../package.json';
import './style.less';

export default defineWidget({
	name,
	version,
	$plugins: [componentPlugin, eventEmitterPlugin, httpClientPlugin, errorPlugin],
	assets: [
		{
			type: 'script',
			source: settings.loginScript,
			optional: true,
			test: 'return Boolean(window.login)'
		},
		{
			type: 'script',
			name: 'widget.js',
			test: 'return window.__merkur__ && window.__merkur__.isRegistered && window.__merkur__.isRegistered("@szn/ribbon")'
		},
		{
			name: 'widget.css',
			type: 'inlineStyle'
		}
	],
	viewFactory: createViewFactory(() => ({
		View
	})),
	load(widget) {
		return {
			...widget?.state,
			unfixed: false
		};
	},
	setup(widget) {
		// Attach error handler
		widget.on(widget, ERROR_EVENTS.ERROR, error => errorHandler(widget, error));

		// Extend client mount
		if (typeof document !== 'undefined') {
			hookMethod(widget, 'mount', (w, originalMount, ...args) => {
				if (document.querySelector(w.containerSelector) === null) {
					widget.emit(ERROR_EVENTS.ERROR, {
						error: {
							status: 556
						}
					});
				}

				return originalMount(w, ...args);
			});
		}

		if (widget.props.debug) {
			enableDebug();
		}

		widget.suggestApi = new SuggestApi(widget);

		return widget;
	},
	setSearchQuery(widget, searchQuery) {
		widget.setState({ searchQuery });
	},
	fixed(widget) {
		widget.setState({ unfixed: false });
	},
	unfixed(widget) {
		widget.setState({ unfixed: true });
	},
	setLinks(widget, links) {
		widget.setState({ links });
	},
	toggleMenu(widget, open) {
		widget.setState(state => ({
			showMenu: open ?? !state.showMenu
		}));
	}
});
